export default __webpack_public_path__ + "img/logo.05deab02.svg";